import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        formSubmission: '='
    },
    template: `
        <div class="loader02" ng-if="!vm.form">{{ 'question.Please wait' | translate }}</div>
        <div class="heading01">
            <h2 ng-if="vm.form &&!vm.error">{{ 'feedback.Feedback form' | translate }}</h2>
            <forms-language-switcher ng-if="vm.formSubmission.isTrial" form-submission="vm.formSubmission" selected-language="vm.language" />
        </div>
        <p ng-if="vm.form && !vm.error">{{ 'token.feedback.feedback_text' | translate }} </p>
        <p ng-if="vm.error" class="alert alert-danger"><span>{{ vm.error }}</span></p>
        <div ng-if="vm.form && !vm.error" class="quiz">
            <p class="desc"><span class="red">*</span> - {{ 'forms.This question is mandatory' | translate }}</p>
            <div ng-repeat="category in vm.categories">
               <evaluation-public-evaluation-category ng-if="category.id"
                   form="vm.form"
                   category="category"
                   opened-tab="vm.openedTab"
                   index="$index"
                   counter="vm.counter"
                   categories-count="vm.categoriesCount"
               ></evaluation-public-evaluation-category>
               <div class="question" ng-if="!category.id" ng-repeat="question in category.questions">
                   <evaluation-public-evaluation-question-radio
                        form="vm.form"
                        answered-questions="vm.answeredQuestions"
                        question="question"
                        counter="vm.counter[question.id]"
                        ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.RADIO"
                   ></evaluation-public-evaluation-question-radio>
                   <evaluation-public-evaluation-question-free-text
                        form="vm.form"
                        counter="vm.counter[question.id]"
                        answered-questions="vm.answeredQuestions"
                        question="question"
                        ng-if="question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT"
                   ></evaluation-public-evaluation-question-free-text>
                </div>
            </div>
            <ul class="actions01">
                <li class="primary"><a class="btn main" ng-click="vm.submit()">{{ vm.getSubmitButtonText() }}</a></li>
                <li class="primary" ng-if="vm.inFrame"><a class="btn bordered02" ng-click="vm.closeModal()">{{ 'general.Later' | translate }}</a></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, $state, $rootScope, $scope, toastr, lodash, FORMS_SUBMISSION_STATUS_ENUM, ModalService,
                 TokenService, QUESTIONS_TYPE_ENUM, FormSubmissionAnswerResource, FormSubmissionResource, ErrorHandlerFactory) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$translate = $translate;
        this.toastr = toastr;
        this.FormSubmissionResource = FormSubmissionResource;
        this.lodash = lodash;
        this.FORMS_SUBMISSION_STATUS_ENUM = FORMS_SUBMISSION_STATUS_ENUM;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.ModalService = ModalService;
        this.TokenService = TokenService;
        this.FormSubmissionAnswerResource = FormSubmissionAnswerResource;
        this.ErrorHandlerFactory = ErrorHandlerFactory;
    }

    $onInit () {
        this.openedTab = 0;
        this.counter = {};
        this.answeredQuestions = 0;
        this.error = null;
        // check whether quiz is accessed via iframe
        this.inFrame = self !== top;
        this.language = this.$translate.use();
        if (this.formSubmission.isTrial) {
            this.language = this.language ? this.language : this.TokenService.getCompanyLanguage();
        }
        const listener = this.$rootScope.$on('cert-feedback:language', (event, language) => {
            this.language = language;
            this.loadTest();
        });
        this.$scope.$on('$destroy', listener);
        this.loadTest();
    }

    loadTest () {
        this.getQuestions().then(() => {
            this.form = {
                language: this.language,
                guid: this.formSubmission.guid,
                formId: this.formSubmission.formId,
                answers: []
            };
        });
    }

    closeModal () {
        this.ModalService.confirm(this.$translate.instant('quiz.Are you sure you do not want to give feedback?'), 'medium')
            .then(() => {
                if (this.inFrame) {
                    parent.postMessage('closeQuiz()', '*');
                }
            });
    }

    submit () {
        if (this.formSubmission.isTrial) {
            this.$state.go('authorized.forms.forms.form.general', { id: this.formSubmission.formId });
            return;
        }
        this.FormSubmissionAnswerResource.batchCreate({ expand: 'form' }, this.form).$promise
            .then((data) => {
                this.formSubmission = data;
                if (data.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.FINISHED) {
                    this.$state.go('feedback.finished', { guid: this.formSubmission.guid });
                    return;
                }
                this.loadTest();
            }).catch(response => {
                // TODO: is this even necessary? We don't actually show each answer errors do we?
                this.handleErrors(response);
            });
    }

    handleErrors (response) {
        const errors = this.ErrorHandlerFactory.parseFormErrors(response);
        const uniqueErrors = [];
        this.lodash.forEach(errors, (error) => {
            if (uniqueErrors.indexOf(error) === -1) {
                this.toastr.error(error);
                uniqueErrors.push(error); // filter out duplicate errors
            }
        });
    }

    getQuestions () {
        const params = {
            guid: this.formSubmission.guid,
            expand: 'activeI18n,questionAnswers',
            pageSize: 0,
            _lang: this.language
        };
        return this.FormSubmissionResource.feedbackQuestions(params).$promise
            .then((categories) => {
                this.categories = categories;
                this.categoriesCount = this.categories.length;

                // create overall question counter
                let counter = 1;
                this.lodash.forEach(categories, (category) => {
                    this.lodash.forEach(category.questions, (question) => {
                        this.counter[question.id] = counter++;
                    });
                });
            }).catch(response => {
                this.error = response.data.message;
            });
    }

    getSubmitButtonText () {
        if (this.formSubmission.isTrial) {
            return this.$translate.instant('forms.Back to form');
        }
        return this.$translate.instant('general.Submit');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/feedback/form/index.js